import type { ReportHistoryTriggerUnionType } from '@api';

type GetReportHistoryTriggerColorReturnType = {
  backgroundColor: string;
  textColor: string;
};

export const getReportHistoryTriggerColor = (
  trigger: ReportHistoryTriggerUnionType
): GetReportHistoryTriggerColorReturnType => {
  switch (trigger) {
    case 'CRON':
      return { backgroundColor: '#E5D4FF', textColor: '#3B1370' };
    case 'MANUAL':
      return { backgroundColor: '#C5E4FA', textColor: '#0A3553' };
  }
};
